import React from 'react'
import { string, node, number, oneOfType } from 'prop-types'

const Insights = ({ category = '', label = '', value = '', version = '', children, ...rest }) =>
  <div
    data-insights-category={category}
    data-insights-label={label}
    data-insights-value={value}
    data-insights-version={version}
    {...rest}
  >
    {children}
  </div>

Insights.propTypes = {
  category: string,
  label: string,
  value: string,
  version: oneOfType([
    string,
    number
  ]),
  children: node

}

export default Insights
